import React from "react"
import "./Contact.css"
import contactImg from "./img/about-9.png"
function Contact() {
  return (
    <div className="contact component__space" id="Contact">
      <div className="row">
        <div className="col__2">
          <div className="contact__box">
            <div className="contact__meta">
              <h1 className="hire__text">Contactez Moi</h1>
              <p className="hire__text white">
                Je suis disponible pour tout travaux independants,appelez moi
                par téléphone au:
              </p>
              <p className="hire__text white">
                <strong>(+237) 693 152 602 / 676 398 049 </strong>
                <br /> ou par mail <br /> <strong>Armel.njike@yahoo.com</strong>
              </p>
            </div>
            <div className="input__box">
              <input
                type="text"
                className="contact name"
                placeholder="Your name *"
              />
              <input
                type="text"
                className="contact email"
                placeholder="Your Email *"
              />
              <input
                type="text"
                className="contact subject"
                placeholder="Write a Subject"
              />
              <textarea
                name="message"
                id="message"
                placeholder="Write Your message"
              ></textarea>
              <button className="btn contact pointer" type="submit">
                Submit
              </button>
            </div>
          </div>
        </div>
        <div className="col__2">
          <img src={contactImg} alt="" className="contact__img" />
        </div>
      </div>
    </div>
  )
}

export default Contact
